export default "__VITE_ASSET__jRsELNio__"